<ngx-spinner bdColor="rgba(115,38,114,0)" size="medium" color="#732672" type="ball-atom" [fullScreen]="true"><p style="color: #732672"> Cargando... </p></ngx-spinner>
<div class="row">
  <div class="col-lg">
    <div style="height: 600px">
      <ng2-pdfjs-viewer #pdfViewer [openFile]="false" [download]="false" [print]="false" ></ng2-pdfjs-viewer>
    </div>
  </div>
</div>
